module.exports = __webpack_public_path__ + "static/media/payment-rejected.6c0c756d.svg";